import {
  faArrowUpRightFromSquare,
  faDownload,
  faFileAlt,
  faTimes,
  faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

import classNames from "classnames";
import { useAppSelector } from "../../../redux/Store";
import { ITRFilingSelector } from "../../../redux/slice/ITRFilingSlice";
import { loggedInUserSelector } from "../../../redux/slice/LoggedInUserSlice";
import FASvgIcon from "../../FASvgIcon";
import { ButtonSpinner } from "../../placeholders";

type DocProps = {
  file?: any;
  uuid: string;
  fileName: string;
  showDeleteBtn?: boolean;
  handleOnPressDelete?: () => void;
  handleOnPressRemove?: () => void;
  showDownloadBtn?: boolean;
  handleOnPressDownload?: () => void;
  showViewBtn?: boolean;
  handleOnPressView?: () => void;
  errorMsg?: string;
};

// for showing selected file with delete, view and download buttons
const UploadedDocument: React.FC<DocProps> = (props: DocProps) => {
  const {
    file = null,
    uuid,
    fileName,
    handleOnPressDelete,
    handleOnPressRemove,
    handleOnPressDownload,
    handleOnPressView,
    showDownloadBtn = false,
    showViewBtn = false,
    showDeleteBtn = false,
    errorMsg = ""
  } = props;

  const { loggedInUser } = useAppSelector(loggedInUserSelector);
  const { currentFilingData } = useAppSelector(ITRFilingSelector);

  return (
    <>
      {(uuid || file) && (
        <div className="eds-drag-upload-group">
          <div className={classNames("selected-file-wrap", errorMsg && "border-danger")}>
            <div className="file-info">
              <FASvgIcon icon={faFileAlt} />

              <span className="text-greyDark text-decoration-none h5 mb-0">
                {fileName || file?.name}
              </span>
            </div>
            <div className="file-actions">
              {file && !uuid && !errorMsg ? (
                <Button variant="transparent" className="icon-only">
                  <ButtonSpinner />
                </Button>
              ) : null}

              {loggedInUser?.uuid === currentFilingData?.userUuid && showDeleteBtn && uuid ? (
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => (handleOnPressDelete ? handleOnPressDelete() : null)}
                >
                  <FASvgIcon icon={faTrashAlt} />
                </Button>
              ) : null}

              {errorMsg ? (
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => (handleOnPressRemove ? handleOnPressRemove() : null)}
                >
                  <FASvgIcon icon={faTimes} />
                </Button>
              ) : null}

              {uuid && showDownloadBtn ? (
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => (handleOnPressDownload ? handleOnPressDownload() : null)}
                >
                  <FASvgIcon icon={faDownload} />
                </Button>
              ) : null}

              {uuid && showViewBtn ? (
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => (handleOnPressView ? handleOnPressView() : null)}
                >
                  <FASvgIcon icon={faArrowUpRightFromSquare} />
                </Button>
              ) : null}
            </div>
          </div>
          {errorMsg ? <div className="upload-error">{errorMsg}</div> : null}
        </div>
      )}
    </>
  );
};
export default UploadedDocument;
